@file:OptIn(InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/chartsproject.app.generated.resources/"

@delegate:ResourceContentHash(-359_204_268)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

@delegate:ResourceContentHash(2_520_111)
internal val Res.string.bar_chart: StringResource by lazy {
      StringResource("string:bar_chart", "bar_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 21),
      ))
    }

@delegate:ResourceContentHash(-605_905_374)
internal val Res.string.bar_stacked_chart: StringResource by lazy {
      StringResource("string:bar_stacked_chart", "bar_stacked_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57, 41),
      ))
    }

@delegate:ResourceContentHash(2_111_655_811)
internal val Res.string.cd_close_dialog: StringResource by lazy {
      StringResource("string:cd_close_dialog", "cd_close_dialog", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99, 39),
      ))
    }

@delegate:ResourceContentHash(1_885_197_310)
internal val Res.string.cd_close_settings: StringResource by lazy {
      StringResource("string:cd_close_settings", "cd_close_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139, 45),
      ))
    }

@delegate:ResourceContentHash(1_513_011_259)
internal val Res.string.cd_hide_parameters: StringResource by lazy {
      StringResource("string:cd_hide_parameters", "cd_hide_parameters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185, 46),
      ))
    }

@delegate:ResourceContentHash(-507_690_378)
internal val Res.string.cd_navigate_back: StringResource by lazy {
      StringResource("string:cd_navigate_back", "cd_navigate_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232, 32),
      ))
    }

@delegate:ResourceContentHash(1_886_444_647)
internal val Res.string.cd_open_settings: StringResource by lazy {
      StringResource("string:cd_open_settings", "cd_open_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 265, 44),
      ))
    }

@delegate:ResourceContentHash(-1_573_909_759)
internal val Res.string.cd_open_style_details: StringResource by lazy {
      StringResource("string:cd_open_style_details", "cd_open_style_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310, 53),
      ))
    }

@delegate:ResourceContentHash(-821_830_830)
internal val Res.string.cd_pause_live_updates: StringResource by lazy {
      StringResource("string:cd_pause_live_updates", "cd_pause_live_updates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 364, 53),
      ))
    }

@delegate:ResourceContentHash(669_827_369)
internal val Res.string.cd_play_live_updates: StringResource by lazy {
      StringResource("string:cd_play_live_updates", "cd_play_live_updates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 418, 52),
      ))
    }

@delegate:ResourceContentHash(1_505_974_269)
internal val Res.string.cd_refresh_data: StringResource by lazy {
      StringResource("string:cd_refresh_data", "cd_refresh_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 471, 39),
      ))
    }

@delegate:ResourceContentHash(-984_300_785)
internal val Res.string.cd_regenerate_chart: StringResource by lazy {
      StringResource("string:cd_regenerate_chart", "cd_regenerate_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 511, 51),
      ))
    }

@delegate:ResourceContentHash(1_685_346_227)
internal val Res.string.cd_select_theme: StringResource by lazy {
      StringResource("string:cd_select_theme", "cd_select_theme", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 563, 47),
      ))
    }

@delegate:ResourceContentHash(-708_718_065)
internal val Res.string.cd_show_parameters: StringResource by lazy {
      StringResource("string:cd_show_parameters", "cd_show_parameters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 611, 46),
      ))
    }

@delegate:ResourceContentHash(-492_944_298)
internal val Res.string.chart_basic: StringResource by lazy {
      StringResource("string:chart_basic", "chart_basic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 658, 27),
      ))
    }

@delegate:ResourceContentHash(29_589_604)
internal val Res.string.chart_custom: StringResource by lazy {
      StringResource("string:chart_custom", "chart_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 686, 28),
      ))
    }

@delegate:ResourceContentHash(2_553_393)
internal val Res.string.dark_mode_off: StringResource by lazy {
      StringResource("string:dark_mode_off", "dark_mode_off", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 715, 25),
      ))
    }

@delegate:ResourceContentHash(2_552_167)
internal val Res.string.dark_mode_on: StringResource by lazy {
      StringResource("string:dark_mode_on", "dark_mode_on", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 741, 24),
      ))
    }

@delegate:ResourceContentHash(-959_261_427)
internal val Res.string.dark_mode_system: StringResource by lazy {
      StringResource("string:dark_mode_system", "dark_mode_system", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 766, 32),
      ))
    }

@delegate:ResourceContentHash(-861_724_022)
internal val Res.string.drawer_dark_mode_subtitle: StringResource by lazy {
      StringResource("string:drawer_dark_mode_subtitle", "drawer_dark_mode_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 799, 53),
      ))
    }

@delegate:ResourceContentHash(-1_811_490_972)
internal val Res.string.drawer_dynamic_colors_disable_hint: StringResource by lazy {
      StringResource("string:drawer_dynamic_colors_disable_hint", "drawer_dynamic_colors_disable_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 853, 98),
      ))
    }

@delegate:ResourceContentHash(1_077_194_467)
internal val Res.string.drawer_dynamic_colors_subtitle: StringResource by lazy {
      StringResource("string:drawer_dynamic_colors_subtitle", "drawer_dynamic_colors_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 952, 70),
      ))
    }

@delegate:ResourceContentHash(-75_263_042)
internal val Res.string.drawer_github_subtitle: StringResource by lazy {
      StringResource("string:drawer_github_subtitle", "drawer_github_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1023, 74),
      ))
    }

@delegate:ResourceContentHash(1_752_823_957)
internal val Res.string.drawer_header_subtitle: StringResource by lazy {
      StringResource("string:drawer_header_subtitle", "drawer_header_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1098, 62),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
internal val Res.string.drawer_header_title: StringResource by lazy {
      StringResource("string:drawer_header_title", "drawer_header_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1161, 39),
      ))
    }

@delegate:ResourceContentHash(54_228_438)
internal val Res.string.drawer_section_appearance: StringResource by lazy {
      StringResource("string:drawer_section_appearance", "drawer_section_appearance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1201, 49),
      ))
    }

@delegate:ResourceContentHash(-2_136_593_858)
internal val Res.string.drawer_section_links: StringResource by lazy {
      StringResource("string:drawer_section_links", "drawer_section_links", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1251, 36),
      ))
    }

@delegate:ResourceContentHash(1_226_263_246)
internal val Res.string.drawer_section_themes: StringResource by lazy {
      StringResource("string:drawer_section_themes", "drawer_section_themes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1288, 37),
      ))
    }

@delegate:ResourceContentHash(1_997_915_644)
internal val Res.string.drawer_title_dark_mode: StringResource by lazy {
      StringResource("string:drawer_title_dark_mode", "drawer_title_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1326, 42),
      ))
    }

@delegate:ResourceContentHash(-1_212_443_219)
internal val Res.string.drawer_title_dynamic_colors: StringResource by lazy {
      StringResource("string:drawer_title_dynamic_colors", "drawer_title_dynamic_colors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1369, 55),
      ))
    }

@delegate:ResourceContentHash(1_445_892_428)
internal val Res.string.drawer_title_github: StringResource by lazy {
      StringResource("string:drawer_title_github", "drawer_title_github", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1425, 35),
      ))
    }

@delegate:ResourceContentHash(433_035_716)
internal val Res.string.github_url: StringResource by lazy {
      StringResource("string:github_url", "github_url", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1524, 70),
      ))
    }

@delegate:ResourceContentHash(1_429_505_610)
internal val Res.string.github_url_content_description: StringResource by lazy {
      StringResource("string:github_url_content_description", "github_url_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1461, 62),
      ))
    }

@delegate:ResourceContentHash(-2_136_774_061)
internal val Res.string.line_chart: StringResource by lazy {
      StringResource("string:line_chart", "line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1595, 26),
      ))
    }

@delegate:ResourceContentHash(2_086_110_003)
internal val Res.string.multi_line_chart: StringResource by lazy {
      StringResource("string:multi_line_chart", "multi_line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1622, 40),
      ))
    }

@delegate:ResourceContentHash(2_603_922)
internal val Res.string.pie_chart: StringResource by lazy {
      StringResource("string:pie_chart", "pie_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1663, 21),
      ))
    }

@delegate:ResourceContentHash(-2_125_727_856)
internal val Res.string.radar_chart: StringResource by lazy {
      StringResource("string:radar_chart", "radar_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1685, 27),
      ))
    }

@delegate:ResourceContentHash(2_052_587_384)
internal val Res.string.style_details_title: StringResource by lazy {
      StringResource("string:style_details_title", "style_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1713, 47),
      ))
    }

@delegate:ResourceContentHash(1_962_339_924)
internal val Res.string.themes_content_description: StringResource by lazy {
      StringResource("string:themes_content_description", "themes_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1761, 58),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("bar_chart", Res.string.bar_chart)
  map.put("bar_stacked_chart", Res.string.bar_stacked_chart)
  map.put("cd_close_dialog", Res.string.cd_close_dialog)
  map.put("cd_close_settings", Res.string.cd_close_settings)
  map.put("cd_hide_parameters", Res.string.cd_hide_parameters)
  map.put("cd_navigate_back", Res.string.cd_navigate_back)
  map.put("cd_open_settings", Res.string.cd_open_settings)
  map.put("cd_open_style_details", Res.string.cd_open_style_details)
  map.put("cd_pause_live_updates", Res.string.cd_pause_live_updates)
  map.put("cd_play_live_updates", Res.string.cd_play_live_updates)
  map.put("cd_refresh_data", Res.string.cd_refresh_data)
  map.put("cd_regenerate_chart", Res.string.cd_regenerate_chart)
  map.put("cd_select_theme", Res.string.cd_select_theme)
  map.put("cd_show_parameters", Res.string.cd_show_parameters)
  map.put("chart_basic", Res.string.chart_basic)
  map.put("chart_custom", Res.string.chart_custom)
  map.put("dark_mode_off", Res.string.dark_mode_off)
  map.put("dark_mode_on", Res.string.dark_mode_on)
  map.put("dark_mode_system", Res.string.dark_mode_system)
  map.put("drawer_dark_mode_subtitle", Res.string.drawer_dark_mode_subtitle)
  map.put("drawer_dynamic_colors_disable_hint", Res.string.drawer_dynamic_colors_disable_hint)
  map.put("drawer_dynamic_colors_subtitle", Res.string.drawer_dynamic_colors_subtitle)
  map.put("drawer_github_subtitle", Res.string.drawer_github_subtitle)
  map.put("drawer_header_subtitle", Res.string.drawer_header_subtitle)
  map.put("drawer_header_title", Res.string.drawer_header_title)
  map.put("drawer_section_appearance", Res.string.drawer_section_appearance)
  map.put("drawer_section_links", Res.string.drawer_section_links)
  map.put("drawer_section_themes", Res.string.drawer_section_themes)
  map.put("drawer_title_dark_mode", Res.string.drawer_title_dark_mode)
  map.put("drawer_title_dynamic_colors", Res.string.drawer_title_dynamic_colors)
  map.put("drawer_title_github", Res.string.drawer_title_github)
  map.put("github_url", Res.string.github_url)
  map.put("github_url_content_description", Res.string.github_url_content_description)
  map.put("line_chart", Res.string.line_chart)
  map.put("multi_line_chart", Res.string.multi_line_chart)
  map.put("pie_chart", Res.string.pie_chart)
  map.put("radar_chart", Res.string.radar_chart)
  map.put("style_details_title", Res.string.style_details_title)
  map.put("themes_content_description", Res.string.themes_content_description)
}
